var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccLoad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Card_load",
    "data-name": "Card load",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7555",
    "data-name": "Rectangle 7555",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30361",
    "data-name": "Group 30361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33409",
    "data-name": "Path 33409",
    d: "M11.892,22.979a10.442,10.442,0,0,1-10.466-9.36c0-.016-.144-1.3,0-1.355l2.189.771a8.289,8.289,0,0,0,8.277,7.607,8.161,8.161,0,0,0,8.167-7.607l2.3-.771a5.459,5.459,0,0,1,0,1.355,10.58,10.58,0,0,1-10.437,9.36ZM6.782,9.882h3.952V.8h2.322V9.882h3.952L13.055,14.8l-1.047,1.3-.089.089-.089-.089-1.1-1.353Z",
    transform: "translate(2.13 2.14)",
    fill: "#b3b6c6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccLoad);
export default __webpack_public_path__ + "static/media/mcc_load.c35b4ee9beeef147d4fb6b23fbe477d6.svg";
export { ForwardRef as ReactComponent };